import { render, staticRenderFns } from "./TipoFamiliarPage.vue?vue&type=template&id=49c34053"
import script from "./TipoFamiliarPage.js?vue&type=script&lang=js&external"
export * from "./TipoFamiliarPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports